import React,{Component} from 'react';
import Sidebar from '../../components/Sidebar';
import Message from './message'
import Front from './front_facer'
import cookie from '../../helper/cookie'
import Relay from 'react-relay';

class Agentsettingspage extends Component
{
  constructor(props)
  {
    super(props);
    var frontfacers = [];
    this.props.viewer.frontFacers.map((object, index) => {
      frontfacers.push({
        pid : object.pid,
        imageLink : object.linkToImage,
        name : object.name
      });
    });

    var hashTags = [];
    this.props.viewer.hashTags.map((object, index) => {
      hashTags.push({
        pid: object.pid,
        tag : object.tag,
        message : object.message
      });
    });
    this.state={frontfacers:frontfacers,hashTags:hashTags}
  }

  render()
  {
    if (cookie.get('access_token') != null) {
    return(
      <div>
          <div className="container row">
            <div className="col-md-1 col-sm-1" style={{backgroundColor:"#e5e5e5",height:"100%"}}>
              <Sidebar source="settings"/>
            </div>
            <div className="col-md-6 col-sm-6" id='message'>
              <Message data={this.state.hashTags} />
            </div>
            <div className="col-md-4 col-sm-4 pull-right" id='front'>
              <Front data={this.state.frontfacers} />
            </div>
          </div>
      </div>
    );
      }
  else{
    window.location.href = "/#/login";
    return(<div></div>);
  }
  }
}

export default Relay.createContainer(Agentsettingspage, {
  initialVariables: {
    status: null
  },
  fragments: {
    viewer: () => Relay.QL`
      fragment on Agent {
        hashTags {
          pid
          tag
          message
        }
        frontFacers {
          pid
          name
          linkToImage
        }
      }
    `
  }
});



/** WEBPACK FOOTER **
 ** ./src/views/AgentSettings/index.js
 **/